import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteIcon } from "../../../../../common/icons/delete.svg";
import { ReactComponent as DuplicateIcon } from "../../../../../common/icons/duplicate.svg";
import { ReactComponent as EditIcon } from "../../../../../common/icons/editDark.svg";

type Props = {
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  index: number;
  id?: string;
  isRowEditable: boolean;
  onDeleteRow: (index: number) => void;
  onCopyRow: (index: number) => void;
  onEdit?: (index: number) => void;
};

export const ActionMenu = ({
  open,
  anchorEl,
  onClose,
  index,
  id,
  isRowEditable,
  onDeleteRow,
  onCopyRow,
  onEdit,
}: Props) => {
  const { t } = useTranslation();

  if (id && anchorEl?.id !== id) return null;

  return (
    <Menu key={index} open={open} anchorEl={anchorEl?.target} onClose={onClose}>
      <List dense disablePadding>
        {onEdit && (
          <ListItem disablePadding>
            <ListItemButton
              sx={{ paddingLeft: "13px", paddingRight: "13px" }}
              onClick={() => {
                onEdit(index);
                onClose();
              }}
            >
              <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
                <EditIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>{t("edit")}</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        )}
        <ListItem disablePadding>
          <ListItemButton
            sx={{ paddingLeft: "13px", paddingRight: "13px" }}
            onClick={() => {
              onCopyRow(index);
              onClose();
            }}
          >
            <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
              <DuplicateIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography>{t("duplicate")}</Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{ paddingLeft: "13px", paddingRight: "13px" }}
            disabled={!isRowEditable}
            onClick={() => {
              onDeleteRow(index);
              onClose();
            }}
          >
            <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ color: "#C50631" }}>{t("delete")}</Typography>
            </ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Menu>
  );
};
